<div class="page-not-found">
  <section class="page-not-found__content container">
    <h1 i18n="@@Error404">Error 404.</h1>
    <h4 i18n="@@PageNotFound">Page Not Found. Please try again.</h4>
    <a [routerLink]="'/'" class="text-end btn btn-link" i18n="@@BackHome"> BACK HOME </a>
  </section>
</div>
